/* eslint @typescript-eslint/no-explicit-any: 0 */
const fake = {};
let isFake = false;
let storage;
try {
    storage = localStorage;
}
catch (e) {
    isFake = true;
    storage = {
        getItem: (k) => fake[k] || null,
        setItem: (k, v) => {
            fake[k] = v;
        },
        removeItem: (k) => {
            delete fake[k];
        },
    };
}
export const clear = ({ keep, only } = {}) => {
    if (keep && only) {
        throw new Error("keep and only are mutually exclusive");
    }
    for (const k in isFake ? fake : storage) {
        if (keep && !keep.includes(k)) {
            storage.removeItem(k);
        }
        if (only && only.includes(k)) {
            storage.removeItem(k);
        }
        if (!keep && !only) {
            storage.removeItem(k);
        }
    }
};
export const setItem = (k, v) => storage.setItem(k, v);
export const hasItem = (k) => Object.hasOwn(storage, k) || Object.hasOwn(fake, k);
export const getItem = (k) => storage.getItem(k);
export const setJson = (k, v) => setItem(k, JSON.stringify(v));
export const getJson = (k) => {
    const v = getItem(k);
    return v === null ? v : JSON.parse(v);
};
export const keys = () => Object.keys(isFake ? fake : storage);
export const cursor = (key, initialState = null) => {
    if (!hasItem(key)) {
        setJson(key, initialState);
    }
    return {
        key,
        initialState,
        set: (v) => setJson(key, v),
        get: () => getJson(key),
    };
};
//# sourceMappingURL=storage.mjs.map